export type HelpAction = { label: string; area: string; page: string };
export type HelpGuide = {
  id: string;
  title: string;
  summary: string;
  category: string;
  areas: string[];
  pages?: string[];
  before: string;
  steps: string[];
  outcome: string;
  problems: { question: string; answer: string }[];
  actions: HelpAction[];
};
export type HelpContent = {
  app: string;
  title: string;
  intro: string;
  support: string;
  guides: HelpGuide[];
};
export type HelpContext = { area: string; page: string; title: string };

/** Page matches rank first, then area matches. Search covers the actual instructions. */
export function findHelpGuides(content: HelpContent, context: HelpContext, query = "", category = "") {
  const words = query.toLocaleLowerCase().trim().split(/\s+/).filter(Boolean);
  const rank = (guide: HelpGuide) =>
    (guide.pages?.includes(context.page) ? 2 : 0) + (guide.areas.includes(context.area) ? 1 : 0);
  return content.guides
    .filter(guide => {
      const text = [
        guide.title,
        guide.summary,
        guide.category,
        guide.before,
        ...guide.steps,
        guide.outcome,
        ...guide.problems.flatMap(problem => [problem.question, problem.answer]),
      ]
        .join(" ")
        .toLocaleLowerCase();
      return (!category || guide.category === category) && words.every(word => text.includes(word));
    })
    .sort((a, b) => rank(b) - rank(a));
}
